import React, { ReactNode } from "react";

interface TabItemProps {
  label: string;
  icon: string;
  isActive: boolean;
  onClick: () => void;
  displayName?: ReactNode;
}

const TabItem: React.FC<TabItemProps> = ({
  label,
  icon,
  isActive,
  onClick,
  displayName,
}) => {
  return (
    <button
      onClick={onClick}
      className={`viewRowButton flex flex-row space-x-2.5 h-[35px] 2xl:h-[40px] px-3.5 2xl:px-4 items-center rounded-[7px] ${
        isActive
          ? "bg-indigo-100/90 text-indigo-700 fill-indigo-700 stroke-indigo-700"
          : "bg-indigo-50/70 text-indigo-400 fill-indigo-400 stroke-indigo-400 hover:text-indigo-700 hover:fill-indigo-700 hover:stroke-indigo-700 duration-200 ease-in-out"
      }`}
    >
      <i className={`text-[16px] 2xl:text-[17px] fa-fw fa-solid ${icon}`}></i>
      {displayName || (
        <h2 className="text-[14px] 2xl:text-[15px] tracking-wide">{label}</h2>
      )}
    </button>
  );
};

export default TabItem;
